import { read } from "./read"

export const userProfile = {
  read,
}
